import { Attr, Model } from 'spraypaint';

import { ApplicationRecord } from './application_record';

@Model()
export default class SsmParameterSync extends ApplicationRecord {
  static jsonapiType = 'ssm_parameter_syncs';

  @Attr() facilityId: string;
}
